import projection from '../generated/pwn5n1f1.json';
import { AcceptanceManifest } from '../types';
export const pwn5n1f1AcceptanceManifest = projection as AcceptanceManifest;
